<template>
  <section id="main-container" style="background-color: rgb(230, 230, 230);">
    <v-container fluid>
      <v-layout flex>
        <v-flex xs12 style="max-width:1020px;margin:0 auto;">
          <div id="centered-content">
            <img
              height="160px"
              style="margin:0 auto; display:block; padding-bottom:40px; "
              slot="activator"
              src="../assets/login-cb-logo.svg"
            />
            <v-layout
              wrap
              row
              :style="$vuetify.breakpoint.mdAndUp && 'min-height:350px;'"
            >
              <v-flex
                xs12
                md6
                class="login-box pa-4"
                style="border-top-right-radius: 5px;border-bottom-right-radius: 0px; border-bottom-left-radius: 0px;border-top-left-radius: 5px;'"
                :style="$vuetify.breakpoint.mdAndUp && 'border-top-right-radius: 0px;border-bottom-right-radius: 0px; border-bottom-left-radius: 5px;border-top-left-radius: 5px;'"
              >
                <v-flex style="display:table; height:100%; width:100%;" class="pa-4">
                  <div style="display:table-cell; vertical-align:middle;">
                    <h1 class="primary--text pb-3">Reset your password</h1>
                    <p>
                      Input the email address associated with your Caseblocks
                      account and if it exists we will send a reset link to you.
                    </p>
                    <v-form ref="form" @keyup.native.enter="resetSubmit">
                      <v-text-field
                        box
                        id="email-field"
                        :rules="emailRules"
                        label="Email address"
                        v-model="email"
                        required
                        class="mb-0"
                      ></v-text-field>

                      <v-flex pt-0>
                        <div id="reset-feedback" :class="feedbackClass" v-if="resetFeedback"><p>{{ resetFeedback }}</p></div>
                        <router-link :to="{ name: 'Login'}">
                          <v-btn
                            block
                            class="ml-0 mb-2 mt-0"
                            color="secondary"
                            :style="$vuetify.breakpoint.mdAndUp && 'width:calc(50% - 10px); float:left; margin-right:20px; margin-bottom:0px !important'"
                          >Back to Login</v-btn>
                        </router-link>
                        <v-btn
                          block
                          class="ml-0 mb-0 mt-0"
                          color="tertiary"
                          @click="resetSubmit"
                          :style="$vuetify.breakpoint.mdAndUp && 'width:calc(50% - 10px)'"
                        >Reset</v-btn>
                      </v-flex>
                    </v-form>
                  </div>
                </v-flex>
              </v-flex>
              <v-flex
                xs12
                md6
                class="promo-box pa-4"
                style="border-top-right-radius: 0px;border-bottom-right-radius: 5px; border-bottom-left-radius: 5px;border-top-left-radius: 0px;'"
                :style="$vuetify.breakpoint.mdAndUp && 'border-top-right-radius: 5px;border-bottom-right-radius: 5px; border-bottom-left-radius: 0px;border-top-left-radius: 0px;'"
              >
                <v-flex style="display:table; height:100%;width:100%;" class="pa-4">
                  <div style="display:table-cell; vertical-align:middle;">
                    <h2 class="pb-2" style="line-height:1.2em;">
                      Explore the latest new
                      features in Caseblocks
                    </h2>
                    <p>
                      We’ve been busy developing and expanding Caseblocks
                      core functionalilty to make it even better.
                    </p>
                    <a href="https://caseblocks.com" class="no-link-style">
                      <v-btn class="ml-0 mt-1" color="secondary" outline>Explore</v-btn>
                    </a>
                  </div>
                </v-flex>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </section>

  <!-- old
  <section id="main-container">
    <v-container>
      <v-layout flex>
        <v-flex
          xs12
          sm12
          md7
          lg5
          :class="{'pl-4 pr-4': $vuetify.breakpoint.smAndDown, ' pl-4 pr-4': $vuetify.breakpoint.mdAndUp}"
        >
          <h1 class="pb-3 primary--text">Forgot Password?</h1>
          <p>Put in the email associated with your account and we'll send you an email to reset your password.</p>
          <div id="forgot-password-container">
            <v-card id="forgot-password-box">
              <v-card-text class="ma-0 pa-0 forgot-password-box-text">
                <div>
                  <v-form ref="form">
                    <v-text-field box id="email-field" label="Email" v-model="email" required></v-text-field>

                    <v-flex pt-0>
                      <div id="reset-feedback" :class="feedbackClass">{{ resetFeedback }}</div>
                      <v-btn class="mt-3 ml-0 mr-3" color="success" @click="resetSubmit">Reset</v-btn>
                      <router-link class="no-link-style" :to="{ name: 'Login'}">
                        <v-btn class="mt-3 ml-0" color="secondary">Back to Login</v-btn>
                      </router-link>

                      <div class="clear"></div>
                    </v-flex>
                  </v-form>
                </div>
              </v-card-text>
            </v-card>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
  -->
</template>
<script>
import Helpers from "../helpers.js"

export default {
  name: "ForgotPassword",
  components: {},
  data: () => {
    return {
      email: "",
      feedbackClass: "feedback-fail",
      resetFeedback: undefined,
      emailRules: [
        v => !!v || "E-mail is required",
        v =>
          /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,63})+$/.test(v) ||
          "E-mail must be valid"
      ]
    }
  },
  methods: {
    resetSubmit() {
      const validation = this.resetValidation(this.email)
      if (validation.success) {
        this.$store.dispatch("requestForgotPassword", this.email )

        this.feedbackClass = "feedback-success"
        this.updateUserFeedback(
          `Instructions on how to reset your password will be sent to the following email address: ${this.email}.`
        )
      } else {
        // Validation unsuccessful
        this.feedbackClass = "feedback-fail"
        this.updateUserFeedback(validation.message)
      }
    },
    resetValidation(email) {
      if (Helpers.isEmpty(email.trim())) {
        return { success: false, message: "Email field is required." }
      }
      return { success: true }
    },
    updateUserFeedback(message) {
      this.resetFeedback = message
      // hide after 3 sesconds
      setTimeout(() => {
        this.resetFeedback = undefined
      }, 10000)
    }
  }
}
</script>
